module.exports = {
    apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
    baseUrl: process.env.VUE_APP_FRONTEND_URL,
    publicPath: process.env.VUE_APP_PUBLIC_PATH ?? '/'
};